import * as React from "react";

const LubricantIcon: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M8.25 6.75v1.5h1.5v1.5H5.671L4.383 7.828 4.147 7.5H.75v4.266l3.75 1.5v5.484h10.898l.212-.328L22.125 9h1.125V7.5h-2.508l-.188.141-4.804 3.609v-1.5h-4.5v-1.5h1.5v-1.5h-4.5zM2.25 9h1.079L4.5 10.758v.867l-2.25-.891V9zm17.086 1.454l-4.711 6.796H6v-6h8.25v3l1.195-.891 3.89-2.905zM22.125 12S21 14.004 21 14.625a1.125 1.125 0 102.25 0c0-.621-1.125-2.625-1.125-2.625z"
                fill="#000"
            />
        </svg>
    )
};
export default React.memo(LubricantIcon);
